var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFadeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: "100%",
    x2: "30%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737e8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9bcc1"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.41 45.74V49.07H34.24V51.41H28.41V56H25.49V43.4H35.02V45.74H28.4H28.41ZM44.77 53.3H38.92L37.81 56H34.81L40.43 43.4H43.31L48.95 56H45.89L44.77 53.3V53.3ZM43.85 51.09L41.85 46.26L39.85 51.09H43.85ZM50.26 43.4H56C57.36 43.4 58.57 43.66 59.62 44.18C60.6521 44.6752 61.5165 45.4619 62.1065 46.4429C62.6965 47.4239 62.9863 48.5562 62.94 49.7C62.9863 50.8438 62.6965 51.9761 62.1065 52.9571C61.5165 53.9381 60.6521 54.7248 59.62 55.22C58.4905 55.7581 57.2509 56.0252 56 56H50.27V43.4H50.26ZM55.84 53.6C57.1 53.6 58.11 53.26 58.86 52.55C59.2382 52.1816 59.5337 51.737 59.7268 51.2456C59.92 50.7542 60.0063 50.2273 59.98 49.7C59.98 48.5 59.61 47.55 58.86 46.85C58.031 46.1148 56.9466 45.7341 55.84 45.79H53.18V53.61H55.84V53.6ZM74.89 53.66V56H65.13V43.4H74.65V45.74H68.03V48.48H73.88V50.74H68.03V53.66H74.89V53.66Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFadeIcon);
export default __webpack_public_path__ + "static/media/Fade-icon.1cf1056042a27384c9ec6273fa50275c.svg";
export { ForwardRef as ReactComponent };